import React, { useEffect } from "react";
import { Dimensions, Image, Text, TouchableOpacity, View, Linking} from "react-native";
import CImage from "../../common/CImage";
import * as RootNavigation from "../../utilities/RootNavigation"
import useStyles from "./LoginTabIcons_Styles";
const isSmallDevice = Dimensions.get('window').width < 767

export default function LoginTabIcons(props) {
    const styles = useStyles();
    return (
        <View>
            <View
                style={[styles.viewStyle1,{ flexDirection: "row", marginTop: 5 }]} >
                <TouchableOpacity onPress={() => { RootNavigation.navigate('SelectUnlockScreen')}}
                    style={styles.activateUserTextWidget}>
                    <Text style={styles.activateUserTextStyle}>
                        {"Activate/Unlock User ID"}
                    </Text>
                    <CImage.RightArrowBig></CImage.RightArrowBig>
                </TouchableOpacity>
                <TouchableOpacity
                    style={styles.tagBalLink}
                    onPress={() => { RootNavigation.navigate("CheckTagBalance") }} >
                    <Text style={styles.checkTagBalanceTextStyle}>
                        {"Check Tag balance"}
                    </Text>
                    <CImage.RightArrowBig></CImage.RightArrowBig>
                </TouchableOpacity>
            </View>
            <View style={styles.tabPlaystoreViewStyle}>
                <TouchableOpacity onPress={() => Linking.openURL("https://play.google.com/store/apps/details?id=com.idfc.etoll&hl=en_IN&gl=US")}>

                    <CImage.PlaystoreIcon></CImage.PlaystoreIcon>
                </TouchableOpacity>
                <TouchableOpacity onPress={() => Linking.openURL("https://apps.apple.com/in/app/idfc-first-bank-fastag/id1547409154")} style={{ paddingLeft: 32 }}>

                    <CImage.AppstoreIcon></CImage.AppstoreIcon>
                </TouchableOpacity>
            </View>
            <TouchableOpacity style={styles.whatsupTextLink} onPress={()=>Linking.openURL("https://api.whatsapp.com/send?phone=919555555555&text=FASTag")}>
                    <CImage.WhatsAppIcon></CImage.WhatsAppIcon>
                    <Text style={styles.whatsupText}>{"Chat with us on WhatsApp"}</Text>
                </TouchableOpacity>
        </View>
    );
}


